export default __webpack_public_path__ + "static/media/upload-red.516e6760.svg";